<template>
  <div class="home">
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">
          <b>首页</b>
        </router-link>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="content" style="padding-top:20px;">
      <el-row :gutter="24" class="row">
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>留学跟进</span>
              <router-link to="/msg_follow">
                <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
              </router-link>
            </div>
            <div class="index-card">
              <div class="index-item" v-for="item in followList" :key="item.id">
                <el-link type="primary" @click="linkGo(item);">
                  <i class="el-icon-bell"></i>
                  {{item.subject}}
                </el-link>
                <span class="right">{{item.createTime}}</span>
              </div>
              <div class="blank" v-if="followList.length==0">暂无数据~</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>留学回访</span>
              <router-link to="/msg_visit">
                <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
              </router-link>
            </div>
            <div class="index-card">
              <div class="index-item" v-for="item in visitList" :key="item.id">
                <el-link type="primary" @click="linkGo(item);">
                  <i class="el-icon-bell"></i>
                  {{item.subject}}
                </el-link>
                <span class="right">{{item.createTime}}</span>
              </div>
              <div class="blank" v-if="visitList.length==0">暂无数据~</div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="24" class="row">
        <el-col :span="24">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>
                留学状态统计
                <span style="font-size:12px;color:#aaa;">(本月跟进)</span>
              </span>
              <router-link to="./common">
                <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
              </router-link>
            </div>
            <div class="index-card">
              <el-row :gutter="24" class="row" style="margin:0px;">
                <el-col :span="3" v-for="item in stateList" :key="item.name" class="stateItem">
                  <div class="state">
                    {{item.name}}
                    <div style="font-size:12px;color:#aaa;">({{item.desc}})</div>
                  </div>
                  <div class="person">
                    <span style="color:#D82C34;font-size:14px;">{{item.count}}人</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <el-row :gutter="24" class="row">
        <el-col :span="10">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>日语资源跟进  </span>
              <router-link to="/msg_japfollow">
                <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
              </router-link>
            </div>
            <div class="index-card">
              <div class="index-item" v-for="item in japfollowList" :key="item.id">
                <el-link type="primary" @click="linkGo(item);">
                  <i class="el-icon-bell"></i>
                  {{item.subject}}
                </el-link>
                <span class="right">{{item.createTime}}</span>
              </div>
              <div class="blank" v-if="followList.length==0">暂无数据~</div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="14">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>日语状态统计 <span style="font-size:12px;color:#aaa;">(本月跟进)</span></span>
              <router-link to="/japcommon">
                <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
              </router-link>
            </div>
            <div class="index-card">
               <el-row :gutter="24" class="row" style="margin:0px;">
                <el-col :span="4" v-for="item in stateList" :key="item.name" class="stateItem">
                  <div class="state">
                    {{item.name}}
                    <div style="font-size:12px;color:#aaa;">({{item.desc}})</div>
                  </div>
                  <div class="person">
                    <span style="color:#32DADD;font-size:14px;">{{item.japcount}}人</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="24" class="row">
        <el-col :span="12">
          <el-card class="box-card collectCard" shadow="always">
            <div class="clearfix" slot="header">
              <span>学校统计</span>
              <router-link to="./collect_school">
                <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
              </router-link>
            </div>
            <div class="index-card" style="height:auto;">
              <div id="School" style="height:260px;"></div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card" shadow="always">
            <div class="clearfix" slot="header">
              <span>地区统计</span>
              <router-link to="./collect_area">
                <el-button style="float: right; padding: 3px 0" type="text">更多</el-button>
              </router-link>
            </div>
            <div class="index-card" style="height:auto;">
              <div id="Area" style="height:260px;"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>-->
    </div>
  </div>
</template>



<script>
  import user from "@/plugins/user.js";
import url from "@/plugins/urlHelper.js";
import "echarts/theme/macarons.js";
import echarts from "echarts";
export default {
  name: "home",
  components: {},
  data() {
    return {
      followList: [], //跟进任务列表
      visitList: [], //回访任务列表
      stateList: [], //状态数据了表
      state: {}, //状态数据
      japfollowList: [] //日语资源更近
    };
  },
  methods: {
    // gotoLogin() {
    //   this.$router.replace("login");
    // },
    //获取任务列表
    getNotice() {
      var link = url.getNotice("getindex");
      var _this = this;
      $.get(link, { type: 1 }, data => {
        _this.followList = data;
      });
      $.get(link, { type: 2 }, data => {
        _this.visitList = data;
      });
      $.get(link, { type: 5 }, data => {
        _this.japfollowList = data;
      });
    },
    //跳转处理
    linkGo: function(item) {
      var url = item.linkUrl;
      if (url) {
        url = JSON.parse(url);
        this.$router.push(url);
      }
      //标记已读处理
      if (item.isRead == false) {
        this.setView(item.id, false);
      }
    },
    //标记已读
    setView: function(id, isReload) {
      var _this = this;
      var link = url.getNotice("setread");
      $.post(link, { id: id }, res => {
        if (res.status) {
          if (isReload) {
            _this.$message({
              type: "success",
              message: res.msg
            });
            _this.getList();
          }
        } else {
          _this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //获取学校统计，地区统计
    getSchool() {
      //柱状图
      var link2 = url.getCollect("GetSchIndex");
      $.get(link2, { top: 5 }, data => {
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(
          document.getElementById("School"),
          "macarons"
        );
        // 绘制图表
        myChart.setOption({
          title: {
            text: "学校申请人数Top5",
            subtext: "数据来自Crm系统",
            x: "center"
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "value",
            boundaryGap: [0, 0.01]
          },
          yAxis: {
            type: "category",
            data: data.name.reverse()
          },
          series: [
            {
              name: "申请人数",
              type: "bar",
              data: data.value.reverse()
            }
          ]
        });
      });
      //饼状图
      var link = url.getCollect("getareaindex");
      $.get(link, { top: 5 }, data => {
        //地区统计
        var areaChart = echarts.init(
          document.getElementById("Area"),
          "macarons"
        );
        // 绘制图表
        areaChart.setOption({
          title: {
            text: "省申请人数Top5",
            subtext: "数据来自Crm系统",
            x: "center"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} 人申请"
          },
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: data,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)"
                }
              }
            }
          ]
        });
      });
    },
    //获取状态统计
    getStateList() {
      var _this = this;
      var link = url.getCollect("getbystate");
      $.get(link, {}, data => {
        _this.stateList = data;
      });
    }
  },
  mounted() {
    if (user.isLogin()) {
      this.getNotice();
      //this.getSchool();
      this.getStateList();
    }
   
  }
};
</script>
<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background-color: #f2f2f2;
}
</style>


<style scoped>
.index-card {
  height: 160px;
  overflow: auto;
}

.blank {
  color: #ddd;
  text-align: center;
  padding-top: 30px;
}
.row {
  margin-bottom: 15px;
}
.index-card {
  clear: both;
}
.index-card .right {
  float: right;
  font-size: 13px;
  color: #aaa;
}
.index-card .index-item {
  padding: 5px 0px;
}
.collectCard .el-card__body {
  padding: 0px !important;
}
.stateItem {
  text-align: center;
  line-height: 3em;
  padding-top: 1em;
}
.stateItem .state {
  font-size: 20px;
  line-height: 30px;
}
.stateItem .person {
  letter-spacing: 2px;
  color: #aaa;
}
</style>
